import { Product } from '../../../api/queries/use-get-products';

export interface TabContentProps {
  product?: Product;
}

export const DATA_UNAVAILABLE_TEXT = 'Data unavailable';
